module.exports = __webpack_public_path__ + "img/leftimageparagraph.2c301d93.png";